import {CityProps, translatedCityProps} from 'modules/cities/types';
import {CompanyProps, translatedCompanyProps} from 'modules/companies/types';
import {TranslatedKeys} from 'shared/types/translated-keys';

export enum CouponTypeEnum {
  percentage = 'percentage',
  value = 'value',
}

export enum SponsorTypeEnum {
  FRANCHISE = 'FRANCHISE',
  COMPANY = 'COMPANY',
  CITY = 'CITY',
}

export interface CouponProps {
  id: string;
  name: string;
  active: boolean;
  companyId?: string;
  company?: CompanyProps;
  cityId?: string;
  city?: CityProps;
  value: number;
  quantity: number;
  notification?: {title: string; body: string};
  type: CouponTypeEnum;
  expiresAt?: string;
  visible: boolean;
  sendNotification: boolean;
  minValue: number;
  sponsorType: SponsorTypeEnum;
  onePerCustomer?: boolean;
  isFixed?: boolean;
}

export const translatedCouponProps: TranslatedKeys<CouponProps> = {
  name: 'Nome',
  active: 'Ativo?',
  companyId: 'Empresa',
  company: {...translatedCompanyProps, name: 'Empresa'},
  cityId: 'Cidade',
  city: {...translatedCityProps, name: 'Cidade'},
  value: 'Valor/Porcentagem',
  quantity: 'Quantidade',
  type: 'Tipo',
  expiresAt: 'Validade',
  visible: 'Visível?',
  notification: {title: 'Título', body: 'Mensagem'},
  sendNotification: 'Enviar notificação?',
  minValue: 'Valor mínimo do pedido',
  sponsorType: 'Patrocinador',
  onePerCustomer: 'Um uso por cliente?',
  isFixed: 'Cupom fixo?',
};
